import { render } from "./TrainingSectionProgramItem.vue?vue&type=template&id=34dba758&scoped=true"
import script from "./TrainingSectionProgramItem.vue?vue&type=script&lang=js"
export * from "./TrainingSectionProgramItem.vue?vue&type=script&lang=js"

import "./TrainingSectionProgramItem.vue?vue&type=style&index=0&id=34dba758&lang=scss&scoped=true"

import exportComponent from "/var/www/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34dba758"]])

export default __exports__